
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.416 6.215H10.5a1.5 1.5 0 0 0 1.5-1.5V2.5A1.5 1.5 0 0 0 10.5 1h-4A1.5 1.5 0 0 0 5 2.5v2.215a1.5 1.5 0 0 0 1.5 1.5h1.151","stroke":"#234652"}}),_c('path',{attrs:{"d":"M9.917 6.152v1.56c0 .88.518 2.076 1.591 2.076h2.903a.91.91 0 0 1 .91.91v2.804H1.68v-2.805a.91.91 0 0 1 .909-.909h2.97c1.369 0 1.592-1.196 1.592-2.075V6.152","stroke":"#234652"}}),_c('path',{attrs:{"d":"M2.652 13v1.699a1 1 0 0 0 1 1h9.696a1 1 0 0 0 1-1v-1.7","stroke":"#234652"}})])
          )
        }
      }
    